<template>
    <footer :class="{ 'entering': isEntering }">

      <div class="footer-grid">
      <section>
        <IO :threshold="0.2" :once="true">
              <h4>London</h4>
              <p>1 Bonny Street </p>
              <p>Camden, London, NW1 9PE</p>
              <p>United Kingdom</p>
              <p>
                <Link to="https://maps.app.goo.gl/fUnnGztE2CzFxmdV9">View on map</Link>
              </p>
          </IO>
      </section>
      <section>
        <IO :delay="0.2"  :threshold="0.2" :once="true">
            <h4>Riyadh</h4>
            <p>3141 Anas Ibn Malik St</p>
            <p>Al Malqa, Riyadh 13521</p>
            <p>Saudi Arabia</p>
            <p><Link to="https://maps.app.goo.gl/zGmiehyjz7qnW8p4A">View on map</Link></p>
          </IO>
        </section>
        <section>
          <IO delay="0.4" :threshold="0.2" :once="true">
            <h4><Link to="/contact">Contact us</Link></h4>
            <p>+44 (0) 20 7916 1827</p>
            <p>Mon-Fri 9 am - 5:30 pm</p>
            <p><Link to="mailto:london@cross-works.com">london@cross-works.com</Link></p>
          </IO>
        </section>
      </div>

      <div class="footer-socials">
            <div class="social-icons">
                <a href="https://www.linkedin.com/company/crossworksltd/" class="social-icon" target="_blank" rel="noopener noreferrer">
                  <LinkedIn />
                </a>

                <a href="https://www.instagram.com/crossworksltd/" class="social-icon" target="_blank" rel="noopener noreferrer">
                  <Instagram />
                </a>

                <a href="https://www.youtube.com/@cross-works" class="social-icon" target="_blank" rel="noopener noreferrer">
                  <YouTube />
                </a>

                <a href="https://www.facebook.com/CrossWorksLtd/" class="social-icon" target="_blank" rel="noopener noreferrer">
                  <Facebook />
                </a>

                <a href="https://x.com/CrossWorksLtd" class="social-icon" target="_blank" rel="noopener noreferrer">
                  <X />
                </a>

            </div>
      </div>
  </footer>


    
            

</template>

<script>

  import { Facebook, Instagram, LinkedIn, X, YouTube } from '@/components/Icons';
  import Link from '@/components/Link.vue';
  import IO from '@/components/IO.vue';


  export default {
      name: "Footer",
      components: {
        Facebook,
        Instagram,
        LinkedIn,
        X,
        YouTube,
        Link,
        IO
      },
      props: {
        isEntering: {
          type: Boolean,
          default: false
        }
      }
  };
</script>

<style lang="scss" scoped>

  @use '../../assets/scss/variables' as *;
  @use '../../assets/scss/mixins' as m;
  @use '../../assets/scss/templates' as *;
  @use '../../assets/scss/typography' as *;
  @use '../../assets/scss/container' as *;

  footer {
    // Smooth entrance animation
    &.entering {
      animation: footerFadeIn 0.8s ease-out;
    }

    .footer-grid{
      border-top: 1px solid var(--theme-border);
      border-bottom: 1px solid var(--theme-border);
      margin-top: auto;
      padding: $spacing-xxl 0;

      @include m.above-tablet-landscape {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: $spacing-xl;

       
      }

    }

    .footer-socials {
      margin: $spacing-xxl auto;
      width: 100%;
      text-align: center;
      position: relative;

      @include m.below-tablet-landscape {
        margin-bottom: 150px;
      }
    }

    .social-icons {
      display: flex;
      justify-content: center; 
      gap: 2rem;
      align-items: center;

      .social-icon {
        display: inline-flex;
        align-items: center;
        width: 30px;
        height: 30px;

        svg {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }



    p{
      line-height: 1.2;
    }
  


    @include m.below-tablet-landscape{
      grid-template-columns: 1fr;
      gap: $spacing-xl;
      text-align: center;

       section{
          margin-bottom: 50px;
          
        }
      
    }

    @extend %container-default;

    section {
      h4 {
        @extend %body-text;
        @extend %font-semibold;
        @extend %h4;
   
        color: var(--theme-link);
        margin-bottom: $spacing-md;

        .Link{
          @extend %h4;
          border-bottom: none;
          color: var(--theme-link);
        }
      }
      
      p {
        color: var(--theme-text);
        margin-bottom: $spacing-sm;
      }
      
      
    }
  }

  // Footer entrance animation
  @keyframes footerFadeIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

</style>